var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpeakerIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-93.3%",
    y: "-87.5%",
    width: "286.7%",
    height: "268.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3a-copy-63",
    transform: "translate(-199.000000, -682.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-7",
    filter: "url(#filter-1)",
    transform: "translate(205.000000, 686.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0085CA",
    cx: 7.5,
    cy: 7.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72647177,6.08222968 C6.43855837,6.17407656 7.12641953,6.22 7.79005525,6.22 C8.28229439,6.22 8.75455071,6.19473454 9.20682419,6.14420362 C9.19875517,6.15142821 9.19063613,6.15860219 9.18246762,6.16572504 L8.515625,13 L6.484375,13 L5.81753238,6.16572504 C5.78645264,6.13862386 5.75608897,6.11078238 5.72647177,6.08222968 Z M5.46068948,5.78 C5.17057529,5.38893483 5,4.91082616 5,4.39455782 C5,3.07208005 6.11928813,2 7.5,2 C8.88071187,2 10,3.07208005 10,4.39455782 C10,4.91082616 9.82942471,5.38893483 9.53931052,5.78 L5.46068948,5.78 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    transform: "translate(7.500000, 7.500000) rotate(-315.000000) translate(-7.500000, -7.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15.5 L7.5,9.06977705",
    id: "Line",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpeakerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/speakerIcon.e27b1e2c4b36d07df3b5f7865a7d0d1b.svg";